import { useRef } from "react"
import { useNavigate } from "react-router-dom"
import { enqueueSnackbar } from "notistack"
import { FormikProps } from "formik"
import { CreateUpdateUserGroupFormValues } from "../userGroupsTypes"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { CreateUpdateUserGroupForm } from "../components/CreateUpdateUserGroupForm"
import { COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE, COMPANY_ADMIN_ROUTE } from "../../../../../../constants/routes"
import { CompanyAdminUserGroupsQuery, createUserGroupForCompany } from "../userGroupsApi"
import { useCurrentCompany } from "../../../../hooks/useCurrentCompany"

export function CreateUserGroup() {
    const { companyId } = useCurrentCompany()
    const navigate = useNavigate()
    const formRef = useRef<FormikProps<CreateUpdateUserGroupFormValues>>(null)

    const handleSaveClick = () => {
        formRef.current?.submitForm()
    }

    const { mutate: callCreateUserGroup } = useApiMutation(createUserGroupForCompany, {
        async onSuccess(_, data, context) {
            await context.queryClient.invalidateQueries({ queryKey: [CompanyAdminUserGroupsQuery.LIST] })
            navigate(COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE)
            if (!data.serviceResponse.displayMessage) return
            enqueueSnackbar({
                variant: "success",
                message: data?.serviceResponse.displayMessage,
            })
        },
    })

    return (
        <>
            <LocalizedStrict id="create-user-group-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_CREATE}
                    title="Create user group"
                    rightElement={
                        <LocalizedStrict id="create-user-group-save-button">
                            <StandardButton type="submit" onClick={handleSaveClick}>
                                Create
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="company-nav-item-home">
                            <BreadcrumbLink to={COMPANY_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-organization-title">
                            <Breadcrumb>Organization</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-organization-user-groups-title">
                            <BreadcrumbLink to={COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE}>
                                User groups
                            </BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-organization-user-group-create-title">
                            <Breadcrumb>Create user group</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <CreateUpdateUserGroupForm
                ref={formRef}
                onSubmit={(data) => {
                    companyId && callCreateUserGroup({ userGroup: data, companyId: companyId })
                }}
            />
        </>
    )
}
